import React, { useState, useEffect, useContext, useRef } from "react";
import "../css/CommonDesign.css";
import bikkuri from "../images/bikkuri.svg";
import icon_batsu from "../images/batsu.svg";
import icon_sankaku from "../images/sankaku.svg";
import icon_maru from "../images/maru.svg";
import icon_minus from "../images/icon_minus.png";
import icon_hatena from "../images/hatena.svg";
import hatena from "../images/hatena.svg";
import { useLocation } from "react-router-dom";
import { Breadcrumbs, Container, Link, Stack, styled, Backdrop, CircularProgress } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MsgContext } from "../../App";
import dayjs from "dayjs";
import axios from "axios";
import { API } from "./constantsFront"
import { CSVLink } from "react-csv";
import MenuMenu from "./MenuMenu";
import { compIconConversion, dataJudge, iconConversion, priorityJudge, PriorityJudgePlantRadio, TableTitle } from "./D001Common";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  // border: `0px solid ${theme.palette.divider}`,
  // '&:not(:last-child)': {
  //   borderBottom: 0,
  // },
  '&:before': {
    display: 'none',
  },
}));

/**
 * 輸出国規制対応情報検索結果
 * @returns 
 */
function D003SearchDetail() {
  const navigate = useNavigate();

  // 輸出可否判定結果
  const [judge, setJudge] = useState([<p class="judge">該当するデータが存在しませんでした</p>]);
  // CSVデータ
  const [csvData, setCsvData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);  // Loading

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  // POSTデータ
  let body = { authKey: API.API_KEY };

  const location = useLocation();
  let dataList = [];
  let productName;
  if (location.state != null) {
    dataList = location.state.dataList;
    productName = location.state.productName;
  }

  // CSVヘッダ
  const csvHeader = [
    { label: "品目", key: "product_name" },
    { label: "輸出先国名", key: "country_name" },
    { label: "総合判定", key: "comp_icon" },
    { label: "植物検疫判定", key: "plan_icon" },
    { label: "植物検疫備考", key: "plan_remarks" },
    { label: "動物衛生・食品衛生判定", key: "animal_icon" },
    { label: "動物衛生・食品衛生備考", key: "animal_remarks" },
    // { label: "動物検疫判定", key: "animal_icon" },
    // { label: "動物検疫備考", key: "animal_remarks" },
    { label: "漁獲証明書判定", key: "marine_icon" },
    { label: "漁獲証明書備考", key: "marine_remarks" },
    { label: "放射性物質判定", key: "radio_icon" },
    { label: "放射性物質備考", key: "radio_remarks" },
    { label: "残留農薬判定", key: "rac_icon" },
    { label: "残留農薬備考", key: "rac_remarks" },
    { label: "食品添加物判定", key: "eu_icon" },
    { label: "食品添加物備考", key: "eu_remarks" },
  ];

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 初期表示
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    window.scrollTo(0, 0);
    setTable();

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;

  }, []);

  // テーブル作成
  async function setTable() {
    try {
      if (dataList.length != 0) {
        let judgeContent = [];
        let tableData = [];

        let res;
        let planNA;
        let animalNA;
        let marineNA;
        let radioNA;
        let racNA;
        let euNA;
        let planNADataList = [];
        let animalNADataList = [];
        let marineNADataList = [];
        let radioNADataList = [];
        let racNADataList = [];
        let euNADataList = [];
        // 植物検疫もしくは動物検疫のNAデータ取得
        body.code = "NA";
        // 植物用NAデータ取得
        res = await axios.post("/m_plan_quar/select", body);
        planNADataList = res.data.dataList;
        // 動物用NAデータ取得
        res = await axios.post("/m_animal_quar/select", body);
        animalNADataList = res.data.dataList;
        // 放射能用NAデータ取得
        res = await axios.post("/m_radio_active/select", body);
        radioNADataList = res.data.dataList;
        // 残留農薬用NAデータ取得
        res = await axios.post("/m_rac_quar/select", body);
        racNADataList = res.data.dataList;
        // 食品添加物用NAデータ取得
        res = await axios.post("/m_eu_quar/select", body);
        euNADataList = res.data.dataList;

        if (
          planNADataList.length > 0
          && animalNADataList.length > 0
          && radioNADataList.length > 0
          && racNADataList.length > 0
          && euNADataList.length > 0
        ) {
          planNA = planNADataList[0];
          animalNA = animalNADataList[0];
          radioNA = radioNADataList[0];
          racNA = racNADataList[0];
          euNA = euNADataList[0];
        } else {
          console.log("planNADataList:" + planNADataList.length);
          console.log("animalNADataList:" + animalNADataList.length);
          console.log("radioNADataList:" + radioNADataList.length);
          console.log("racNADataList:" + racNADataList.length);
          console.log("euNADataList:" + euNADataList.length);
          return setMsg("NAデータが存在しません。管理者にお問い合わせください。");
        }

        // Loading
        setIsLoading(true);

        tableData = await setTableData(dataList, planNA, animalNA, radioNA, racNA, euNA);

        judgeContent.push(
          <div>
            <div >
              {/* <p class="table-title">{productName}</p> */}
              <p class="table-title">{TableTitle(dataList, productName)}</p>
              <div class="table-scroll">
                <table bordercolor="gainsboro"
                  style={{ tableLayout: "fixed" }}>
                  {/* <thead className="thead1">
                  <tr>
                    <th className="th1" colspan="5">{productCode}</th>
                  </tr>
                </thead> */}
                  <thead className="table-d003">
                    <tr>
                      {/* <th style={{
                        minWidth: "90px"
                        , backgroundColor: "#EDEEF2"
                      }}>品目</th> */}
                      <th style={{
                        minWidth: "90px"
                        , backgroundColor: "#EDEEF2"
                      }}>輸出対象国</th>
                      <th
                        style={{
                          backgroundColor: "#1B335E"
                          , color: "#FFFFFF"
                          , border: "3px solid #1B335E"
                          , minWidth: "90px"
                        }}>
                        総合判定
                      </th>
                      <th colspan="3"
                        style={{ backgroundColor: "#EDEEF2", width: "1000px" }}>規制</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">{tableData}</tbody>
                </table>
              </div>
            </div>
          </div>
        );
        setJudge(judgeContent);
      } else {
        setJudge([<p class="judge">該当するデータが存在しませんでした</p>]);
      }
    } catch (err) {
      console.log(err)
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    } finally {
      setIsLoading(false);
    }
  }

  // テーブルのデータ作成
  async function setTableData(dataList, planNA, animalNA, radioNA, racNA, euNA) {
    let tableData = [];
    let csvData = [];
    for (let i in dataList) {
      // 放射線データ取得
      let radioDataList = [];

      let countryName = dataList[i].country_name;
      let plantTableData = [];
      let animalTableData = [];
      let marineTableData = [];
      let radioTableData = [];
      let racTableData = [];
      let euTableData = [];
      let planRegulationData = [];
      let animalRegulationData = [];
      let marineRegulationData = [];
      let minPackingList = [];
      let racRegulationData = [];
      let euRegulationData = [];

      let packingName = "";
      let prefCode = "";
      let icon = "";
      let supplement = "";
      let specialCond = "";
      let regulation = "";
      let remarks = "";
      let inquiry = "";
      let url = "";
      let enableDate = "";

      // 植物検疫もしくは動物検疫用
      let supplementArr = [];
      let packing = [];
      let exportability = [];

      // 漁獲証明書用
      let marineSupplementArr = [];

      // 放射能用
      let kisei = [];
      let radioExportability = [];

      let racSupplementArr = [];
      let euSupplementArr = [];

      // 総合判定
      let compJudgeSentence = {
        icon: "", // 輸出可否コード
        // img: "", // 画像ファイル
        supplement: "", // 補足文言
      }
      // 植物判定
      let planSentence = {
        icon: "",
        img: "",
        supplement: "",
        special_cond: "",
        url: "",
        enable_date: "",
        packing_name: "",
      }
      // 動物判定
      let animalSentence = {
        icon: "",
        img: "",
        supplement: "",
        special_cond: "",
        url: "",
        enable_date: "",
      }
      // 漁獲証明書判定
      let marineSentence = {
        icon: "",
        img: "",
        supplement: "",
        special_cond: "",
        url: "",
        enable_date: "",
      }
      // 放射能判定
      let radioSentence = {
        icon: "",
        img: "",
        supplement: "",
        regulation: "",
        remarks: "",
        inquiry: "",
        url: "",
        enable_date: "",
        pref_code: "",
      }
      // 残留農薬判定
      let racSentence = {
        icon: "",
        img: "",
        supplement: "",
        special_cond: "",
        url: "",
        enable_date: "",
      }
      // 食品添加物判定
      let euSentence = {
        icon: "",
        img: "",
        supplement: "",
        special_cond: "",
        url: "",
        enable_date: "",
      }

      // CSV用の判定詳細
      let csvSentence = {
        plan_remarks: "",
        radio_remarks: "",
      }

      let msg = "";
      // 植物検疫用
      let iconArr = [];
      // let exIcon = "";

      console.log(dataList[i])

      // 植物判定
      if (dataList[i].plan_product_code) {
        // 梱包方法取得
        body.countryCode = dataList[i].country_code;
        body.productCode = dataList[i].plan_product_code;
        const res = await axios.post("/m_plan_quar/select/packing", body);
        minPackingList = res.data.dataList;
      }

      if (minPackingList.length > 0) {
        for (let i in minPackingList) {
          if (dataJudge(minPackingList[i].exportability_code)) {
            if (minPackingList[i].packing_name) {
              packingName = minPackingList[i].packing_name;
            } else {
              packingName = minPackingList[i].packing;
            }

            icon = minPackingList[i].exportability_code;
            supplement = minPackingList[i].supplement;
            specialCond = minPackingList[i].special_cond;
            url = minPackingList[i].url;
            enableDate = dayjs(minPackingList[i].enable_date).format("YYYY年MM月DD日");
          } else {
            packingName = planNA.packing;
            icon = planNA.exportability_code;
            supplement = planNA.supplement;
            specialCond = planNA.special_cond;
            url = planNA.url;
            enableDate = dayjs(planNA.enable_date).format("YYYY年MM月DD日");
          }

          // 1番目の梱包方法詳細を取得
          if (i == 0) {
            planSentence = {
              icon: icon,
              img: iconConversion(icon),
              supplement: supplement,
              special_cond: specialCond,
              url: url,
              enable_date: enableDate,
              packing_name: packingName,
            }
          }

          // 判定アイコン取得
          iconArr.push(icon);

          // if (plantPriorityJudge(exIcon, icon)) {
          //   exIcon = icon;
          // }

          csvSentence.plan_remarks +=
            (
              (i == 0 ? enableDate : "\n" + enableDate)
              + "\n" + packingName
              + "\n" + icon
              + "\n" + supplement
              + "\n" + specialCond
              + "\n" + url
            ).replace(/\n{2,}/g, "\n");

          exportability.push(
            <tbody>
              <tr>
                <td className="min-td" style={{ textAlign: "center" }}>
                  {packingName}
                </td>
                <td className="min-td" style={{ textAlign: "center" }}>
                  {/* {minPackingList[i].exportability_code} */}
                  <img src={iconConversion(icon)} />
                </td>
                <td className="min-td2" style={{ textAlign: "left" }}>
                  <Stack spacing={0}>
                    {/* 補足文言 */}
                    <div>{supplement}</div>
                    {/* 注釈 */}
                    <div>{specialCond}</div>
                    {/* URL */}
                    <div>参考URL</div>
                    <div style={{ wordBreak: "break-all" }}>
                      {urlSplit(url)}
                    </div>
                  </Stack>
                </td>
              </tr>
            </tbody>
          );
        }

        // 植物検疫用アイコン判定
        // if (exIcon) {
        //   planSentence.icon = exIcon;
        //   planSentence.img = iconConversion(exIcon);
        // } else {
        //   // アイコンが全て同じか判定
        //   const isAllEqual = array => array.every(value => value === array[0]);
        //   if(isAllEqual(iconArr)){
        //     planSentence.icon = iconArr[0];
        //     planSentence.img = iconConversion(iconArr[0]);
        //   }else{
        //     planSentence.icon = "△";
        //     planSentence.img = iconConversion("△");
        //   }
        // }
        // 植物検疫用アイコン判定
        planSentence.icon = PriorityJudgePlantRadio(iconArr);
        planSentence.img = iconConversion(planSentence.icon);

        // 植物検疫用メッセージ
        //  判定結果が全て同じ場合はメッセージを表示しない。１つでも違う場合はメッセージを表示する。
        let packingMsg;
        if (iconArr.every(value => value == iconArr[0])) {
          packingMsg = "";
        } else {
          if (dataList[i].country_code == "840") {
            packingMsg = <div>輸送方法（貨物、郵便、携帯品）によって、植物検疫条件が異なりますのでご注意ください。<br />
              この判定結果は、アメリカ合衆国の本土のみが対象となっております。</div>;
          } else {
            packingMsg = "輸送方法によって判定が違いますのでご注意ください。";
          }
        }

        packing.push(
          <>
            <p>{packingMsg}</p>
            <div className="d002_item">
              <table bordercolor="darkgray" style={{ minWidth: "100%", fontSize: "14px" }}>
                <thead className="thead2">
                  <tr>
                    <th>輸送方法</th>
                    <th>輸出可否判定</th>
                    <th >備考</th>
                  </tr>
                </thead>
                {exportability}
              </table>
            </div>
          </>
        );
      } else {
        planSentence = {
          icon: planNA.exportability_code,
          img: iconConversion(planNA.exportability_code),
          supplement: planNA.supplement,
          special_cond: planNA.special_cond,
          url: planNA.url,
          enable_date: dayjs(planNA.enable_date).format("YYYY年MM月DD日"),
          packing_name: planNA.packing,
        }

        csvSentence.plan_remarks =
          (
            planSentence.enable_date
            + "\n" + planSentence.packing_name
            + "\n" + planSentence.icon
            + "\n" + planSentence.supplement
            + "\n" + planSentence.special_cond
            + "\n" + planSentence.url
          ).replace(/\n{2,}/g, "\n");

        packing = setNAPacking(planNA);
      }

      if (planSentence.icon == "?") {
        msg = "輸出できるかどうかの情報を把握していません。";
      } else if (planSentence.icon == "X") {
        msg = "輸出できません。";
      } else {
        msg = "輸出をするための条件があります。";
      }

      // 植物検疫
      planRegulationData =
        <>
          <p style={{ textAlign: "right", fontSize: 15, marginBlockStart: 0, marginBlockEnd: 0 }}>有効日：{planSentence.enable_date}</p>
          <Stack spacing={2} direction="row" >
            <Accordion style={{ width: "100%" }}>
              <AccordionSummary
                style={{
                  paddingLeft: "0px"
                }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography color="#3B6FCC">{msg}</Typography>
              </AccordionSummary>
              <AccordionDetails >
                <Typography >
                  {packing}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </>

      // 動物判定
      if (dataList[i].animal_product_code) {
        if (dataJudge(dataList[i].animal_exportability_code)) {
          icon = dataList[i].animal_exportability_code;
          supplement = dataList[i].animal_supplement;
          specialCond = dataList[i].animal_special_cond;
          url = dataList[i].animal_url;
          enableDate = dayjs(dataList[i].animal_enable_date).format("YYYY年MM月DD日");
        } else {
          icon = animalNA.exportability_code;
          supplement = animalNA.supplement;
          specialCond = animalNA.special_cond;
          url = animalNA.url;
          enableDate = dayjs(animalNA.enable_date).format("YYYY年MM月DD日");
        }
        animalSentence = {
          icon: icon,
          img: iconConversion(icon),
          supplement: supplement,
          special_cond: specialCond,
          url: url,
          enable_date: enableDate,
        }

        // 補足文言
        if (animalSentence.supplement) {
          supplementArr.push(<div>{animalSentence.supplement}</div>);
        }
        // 注釈
        if (animalSentence.special_cond) {
          supplementArr.push(<div>{animalSentence.special_cond}</div>);
        }
        // URL
        if (animalSentence.url) {
          supplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {/* <Link href={judgeSentence.url} target="_blank">{judgeSentence.url}</Link></div> */}
                {urlSplit(animalSentence.url)}
              </div>
            </div>
          );
        }
      } else {
        animalSentence = {
          icon: animalNA.exportability_code,
          img: iconConversion(animalNA.exportability_code),
          supplement: animalNA.supplement,
          special_cond: animalNA.special_cond,
          url: animalNA.url,
          enable_date: dayjs(animalNA.enable_date).format("YYYY年MM月DD日"),
        }

        // 補足文言
        if (animalNA.supplement) {
          supplementArr.push(<div>{animalNA.supplement}</div>);
        }
        // 注釈
        if (animalNA.special_cond) {
          supplementArr.push(<div>{animalNA.special_cond}</div>);
        }
        // URL
        if (animalNA.url) {
          supplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {urlSplit(animalNA.url)}
              </div>
            </div>
          );
        }
      }

      if (animalSentence.icon == "?") {
        msg = "輸出できるかどうかの情報を把握していません。";
      } else if (animalSentence.icon == "X") {
        msg = "輸出できません。";
      } else {
        msg = "輸出をするための条件があります。";
      }

      // 動物検疫
      animalRegulationData =
        <>
          <p style={{ textAlign: "right", fontSize: 15, marginBlockStart: 0, marginBlockEnd: 0 }}>有効日：{animalSentence.enable_date}</p>
          <Stack spacing={2} direction="row" >
            <Accordion style={{ width: "100%" }}>
              <AccordionSummary
                style={{
                  paddingLeft: "0px"
                }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography color="#3B6FCC">{msg}</Typography>
              </AccordionSummary>
              <AccordionDetails >
                <Typography >
                  {supplementArr}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </>

      // 漁獲証明書判定
      if (dataList[i].marine_exportability_code) {
        if (dataJudge(dataList[i].marine_exportability_code)) {
          icon = dataList[i].marine_exportability_code;
          supplement = dataList[i].marine_supplement;
          specialCond = dataList[i].marine_special_cond;
          url = dataList[i].marine_url;
          enableDate = dayjs(dataList[i].animal_enable_date).format("YYYY年MM月DD日");
        } else {
          icon = animalNA.marine_exportability_code;
          supplement = animalNA.marine_supplement;
          specialCond = animalNA.marine_special_cond;
          url = animalNA.marine_url;
          enableDate = dayjs(animalNA.enable_date).format("YYYY年MM月DD日");
        }
        marineSentence = {
          icon: icon,
          img: iconConversion(icon),
          supplement: supplement,
          special_cond: specialCond,
          url: url,
          enable_date: enableDate,
        }

        // 補足文言
        if (marineSentence.supplement) {
          marineSupplementArr.push(<div>{marineSentence.supplement}</div>);
        }
        // 注釈
        if (marineSentence.special_cond) {
          marineSupplementArr.push(<div>{marineSentence.special_cond}</div>);
        }
        // URL
        if (marineSentence.url) {
          marineSupplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {/* <Link href={judgeSentence.url} target="_blank">{judgeSentence.url}</Link></div> */}
                {urlSplit(marineSentence.url)}
              </div>
            </div>
          );
        }
      } else {
        marineSentence = {
          icon: animalNA.marine_exportability_code,
          img: iconConversion(animalNA.marine_exportability_code),
          supplement: animalNA.marine_supplement,
          special_cond: animalNA.marine_special_cond,
          url: animalNA.marine_url,
          enable_date: dayjs(animalNA.enable_date).format("YYYY年MM月DD日"),
        }

        // 補足文言
        if (animalNA.marine_supplement) {
          marineSupplementArr.push(<div>{animalNA.supplement}</div>);
        }
        // 注釈
        if (animalNA.marine_special_cond) {
          marineSupplementArr.push(<div>{animalNA.special_cond}</div>);
        }
        // URL
        if (animalNA.marine_url) {
          marineSupplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {urlSplit(animalNA.marine_url)}
              </div>
            </div>
          );
        }
      }

      if (marineSentence.icon == "?") {
        msg = "輸出できるかどうかの情報を把握していません。";
      } else if (marineSentence.icon == "X") {
        msg = "輸出できません。";
      } else {
        msg = "輸出をするための条件があります。";
      }

      // 漁獲証明書
      marineRegulationData =
        <>
          <p style={{ textAlign: "right", fontSize: 15, marginBlockStart: 0, marginBlockEnd: 0 }}>有効日：{animalSentence.enable_date}</p>
          <Stack spacing={2} direction="row" >
            <Accordion style={{ width: "100%" }}>
              <AccordionSummary
                style={{
                  paddingLeft: "0px"
                }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography color="#3B6FCC">{msg}</Typography>
              </AccordionSummary>
              <AccordionDetails >
                <Typography >
                  {marineSupplementArr}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </>

      // 放射能判定
      let radioRegulationData = "";
      if (dataList[i].product_name) {
        radioDataList = await getRadioData(dataList[i].country_code, dataList[i].product_name);
      }

      if (radioDataList.length > 0) {
        let iconRadArr = [];

        for (let i in radioDataList) {
          radioExportability.push(
            <tbody>
              <tr>
                <td className="min-td" style={{ textAlign: "center" }}>{radioDataList[i].pref_code}</td>
                <td className="min-td" style={{ textAlign: "center" }}>{radioDataList[i].regulation}</td>
                <td className="min-td2" style={{ textAlign: "left" }}>
                  <Stack spacing={0}>
                    {/* 補足文言 */}
                    <div>{radioDataList[i].supplement}</div>
                    {/* 備考 */}
                    <div>{radioDataList[i].remarks}</div>
                    {/* お問い合わせ先 */}
                    <div>お問い合わせ先</div>
                    <div>{radioDataList[i].inquiry}</div>
                    {/* URL */}
                    <div>参考URL</div>
                    <div style={{ wordBreak: "break-all" }}>
                      {urlSplit(radioDataList[i].url)}
                    </div>
                  </Stack>
                </td>
              </tr>
            </tbody>
          );

          if (dataJudge(radioDataList[i].exportability_code)) {
            prefCode = radioDataList[i].pref_code;
            icon = radioDataList[i].exportability_code;
            supplement = radioDataList[i].supplement;
            regulation = radioDataList[i].regulation;
            remarks = radioDataList[i].remarks;
            inquiry = radioDataList[i].inquiry;
            url = radioDataList[i].url;
            enableDate = dayjs(radioDataList[i].enable_date).format("YYYY年MM月DD日");
          } else {
            //　国別NAデータ取得
            body = { authKey: API.API_KEY };
            body.productCode = "NA";
            body.countryCode = dataList[i].country_code;
            let res = await axios.post("/m_radio_active_product/select/radio", body);
            if (res.data.dataList.length > 0) {
              let specifyRadioNA = res.data.dataList[0];
              prefCode = specifyRadioNA.pref_code;
              icon = specifyRadioNA.exportability_code;
              supplement = specifyRadioNA.supplement;
              regulation = specifyRadioNA.regulation;
              remarks = specifyRadioNA.remarks;
              inquiry = specifyRadioNA.inquiry;
              url = specifyRadioNA.url;
              enableDate = dayjs(specifyRadioNA.enable_date).format("YYYY年MM月DD日");
            } else {
              prefCode = radioNA.pref_code;
              icon = radioNA.exportability_code;
              supplement = radioNA.supplement;
              regulation = radioNA.regulation;
              remarks = radioNA.remarks;
              inquiry = radioNA.inquiry;
              url = radioNA.url;
              enableDate = dayjs(radioNA.enable_date).format("YYYY年MM月DD日");
            }
          }
          if (priorityJudge(radioSentence.icon, icon)) {
            radioSentence = {
              icon: icon,
              img: iconConversion(icon),
              supplement: supplement,
              regulation: regulation,
              remarks: remarks,
              inquiry: inquiry,
              url: url,
              enable_date: enableDate,
              pref_code: prefCode,
            }
          }

          // 判定アイコン取得
          iconRadArr.push(icon);

          csvSentence.radio_remarks +=
            (
              (i == 0 ? enableDate : "\n" + enableDate)
              + "\n" + prefCode
              + "\n" + regulation
              + "\n" + supplement
              + "\n" + remarks
              + "\n" + inquiry
              + "\n" + url
            ).replace(/\n{2,}/g, "\n");
        }

        // 放射性物質アイコン判定
        radioSentence.icon = PriorityJudgePlantRadio(iconRadArr);
        radioSentence.img = iconConversion(radioSentence.icon);

      } else {
        //　国別NAデータ取得
        body = { authKey: API.API_KEY };
        body.productCode = "NA";
        body.countryCode = dataList[i].country_code;
        let res = await axios.post("/m_radio_active_product/select/radio", body);
        if (res.data.dataList.length > 0) {
          let specifyRadioNA = res.data.dataList[0];
          prefCode = specifyRadioNA.pref_code;
          icon = specifyRadioNA.exportability_code;
          supplement = specifyRadioNA.supplement;
          regulation = specifyRadioNA.regulation;
          remarks = specifyRadioNA.remarks;
          inquiry = specifyRadioNA.inquiry;
          url = specifyRadioNA.url;
          enableDate = dayjs(specifyRadioNA.enable_date).format("YYYY年MM月DD日");

          radioExportability.push(
            <tbody>
              <tr>
                <td className="min-td" style={{ textAlign: "center" }}>{specifyRadioNA.pref_code}</td>
                <td className="min-td" style={{ textAlign: "center" }}>{specifyRadioNA.regulation}</td>
                <td className="min-td2" style={{ textAlign: "left" }}>
                  <Stack spacing={0}>
                    {/* 補足文言 */}
                    <div>{specifyRadioNA.supplement}</div>
                    {/* 備考 */}
                    <div>{specifyRadioNA.remarks}</div>
                    {/* お問い合わせ先 */}
                    <div>お問い合わせ先</div>
                    <div>{specifyRadioNA.inquiry}</div>
                    {/* URL */}
                    <div>参考URL</div>
                    <div style={{ wordBreak: "break-all" }}>
                      {urlSplit(specifyRadioNA.url)}
                    </div>
                  </Stack>
                </td>
              </tr>
            </tbody>
          );
        } else {
          prefCode = radioNA.pref_code;
          icon = radioNA.exportability_code;
          supplement = radioNA.supplement;
          regulation = radioNA.regulation;
          remarks = radioNA.remarks;
          inquiry = radioNA.inquiry;
          url = radioNA.url;
          enableDate = dayjs(radioNA.enable_date).format("YYYY年MM月DD日");

          radioExportability.push(
            <tbody>
              <tr>
                <td className="min-td" style={{ textAlign: "center" }}>{radioNA.pref_code}</td>
                <td className="min-td" style={{ textAlign: "center" }}>{radioNA.regulation}</td>
                <td className="min-td2" style={{ textAlign: "left" }}>
                  <Stack spacing={0}>
                    {/* 補足文言 */}
                    <div>{radioNA.supplement}</div>
                    {/* 備考 */}
                    <div>{radioNA.remarks}</div>
                    {/* お問い合わせ先 */}
                    <div>お問い合わせ先</div>
                    <div>{radioNA.inquiry}</div>
                    {/* URL */}
                    <div>参考URL</div>
                    <div style={{ wordBreak: "break-all" }}>
                      {urlSplit(radioNA.url)}
                    </div>
                  </Stack>
                </td>
                {/* <td className="td2" style={{ textAlign: "center" }}>{radioNA.exportability_code}</td> */}
              </tr>
            </tbody>
          );
        }

        radioSentence = {
          icon: icon,
          img: iconConversion(icon),
          supplement: supplement,
          regulation: regulation,
          remarks: remarks,
          inquiry: inquiry,
          url: url,
          enable_date: enableDate,
          pref_code: prefCode,
        }

        csvSentence.radio_remarks =
          (
            radioSentence.enable_date
            + "\n" + radioSentence.pref_code
            + "\n" + radioSentence.regulation
            + "\n" + radioSentence.supplement
            + "\n" + radioSentence.remarks
            + "\n" + radioSentence.inquiry
            + "\n" + radioSentence.url
          ).replace(/\n{2,}/g, "\n");
      }

      kisei.push(
        <div className="d002_item">
          <table bordercolor="darkgray" style={{ minWidth: "100%", fontSize: "14px" }}>
            <thead className="thead2">
              <tr>
                <th>対象県</th>
                <th>規制内容</th>
                <th >備考</th>
                {/* <th>輸出可否判定</th> */}
              </tr>
            </thead>
            {radioExportability}
          </table>
        </div>
      );

      if (radioSentence.icon == "?") {
        msg = "輸出できるかどうかの情報を把握していません。";
      } else if (radioSentence.icon == "X") {
        msg = "輸出できません。";
      } else {
        msg = "輸出をするための条件があります。";
      }
      //2023/09/06 ins start
      //中国、香港、マカオの場合、放射性物質欄にメッセージを表示する
      let msg2;
      switch (dataList[i].country_code) {
        case "156": //中国
        case "344": //香港
        case "446": //マカオ
          msg2 =
          <>
            <div style={{color: "black", fontSize: "14px"}}>
              ALPS処理水の海洋放出に伴い、中国・香港・マカオが規制を強化しております。
              <br/>
              具体的な規制の内容については、農林水産省ウェブサイトをご確認ください。
              {urlSplit("https://www.maff.go.jp/j/export/e-shorisui/kaiyou_houshutsu.html")}
            </div>
          </>
          break;
        case "643": //ロシア連邦
          msg2 =
          <>
            <div style={{color: "black", fontSize: "14px"}}>
              ALPS処理水の海洋放出に伴い、ロシアは規制を強化しています。
              <br/>
              具体的な規制の内容については、農林水産省ウェブサイトをご確認ください。
              {urlSplit("https://www.maff.go.jp/j/export/e-shorisui/kaiyou_houshutsu.html")}
            </div>
          </>
          break;
      }
      //2023/09/06 ins end

      radioRegulationData =
        <>
          <p style={{ textAlign: "right", fontSize: 15, marginBlockStart: 0, marginBlockEnd: 0 }}>有効日：{radioSentence.enable_date}</p>
          <Stack spacing={2} direction="row">
            <Accordion style={{ width: "100%" }}>
              <AccordionSummary
                style={{
                  paddingLeft: "0px"
                }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography color="#3B6FCC">{msg}{msg2}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {kisei}
                  {/* {radioSupplementArr} */}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </>

      // 残留農薬判定
      if (dataList[i].rac_product_code) {
        if (dataJudge(dataList[i].rac_exportability_code)) {
          icon = dataList[i].rac_exportability_code;
          supplement = dataList[i].rac_supplement;
          specialCond = dataList[i].rac_special_cond;
          url = dataList[i].rac_url;
          enableDate = dayjs(dataList[i].rac_enable_date).format("YYYY年MM月DD日");
        } else {
          icon = racNA.exportability_code;
          supplement = racNA.supplement;
          specialCond = racNA.special_cond;
          url = racNA.url;
          enableDate = dayjs(racNA.enable_date).format("YYYY年MM月DD日");
        }
        racSentence = {
          icon: icon,
          img: iconConversion(icon),
          supplement: supplement,
          special_cond: specialCond,
          url: url,
          enable_date: enableDate,
        }

        // 補足文言
        if (racSentence.supplement) {
          racSupplementArr.push(<div>{racSentence.supplement}</div>);
        }
        // 注釈
        if (racSentence.special_cond) {
          racSupplementArr.push(<div>{racSentence.special_cond}</div>);
        }
        // URL
        if (racSentence.url) {
          racSupplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {/* <Link href={judgeSentence.url} target="_blank">{judgeSentence.url}</Link></div> */}
                {urlSplit(racSentence.url)}
              </div>
            </div>
          );
        }
        // 残留農薬チェック画面
        racSupplementArr.push(
          <p>
            当サイト「
            <Link onClick={() => racClick(dataList[i].country_code, dataList[i].product_code)} style={{ cursor: "pointer" }}>残留農薬チェック</Link>
            」で、各国の農薬規制情報を検索いただけます。是非ご利用ください。
          </p>
        );
      } else {
        racSentence = {
          icon: racNA.exportability_code,
          img: iconConversion(racNA.exportability_code),
          supplement: racNA.supplement,
          special_cond: racNA.special_cond,
          url: racNA.url,
          enable_date: dayjs(racNA.enable_date).format("YYYY年MM月DD日"),
        }

        // 補足文言
        if (racNA.supplement) {
          racSupplementArr.push(<div>{racNA.supplement}</div>);
        }
        // 注釈
        if (racNA.special_cond) {
          racSupplementArr.push(<div>{racNA.special_cond}</div>);
        }
        // URL
        if (racNA.url) {
          racSupplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {urlSplit(racNA.url)}
              </div>
            </div>
          );
        }
      }

      if (racSentence.icon == "?") {
        msg = "輸出できるかどうかの情報を把握していません。";
      } else if (racSentence.icon == "X") {
        msg = "輸出できません。";
      } else {
        msg = "輸出をするための条件があります。";
      }

      // 残留農薬検疫
      racRegulationData =
        <>
          <p style={{ textAlign: "right", fontSize: 15, marginBlockStart: 0, marginBlockEnd: 0 }}>有効日：{racSentence.enable_date}</p>
          <Stack spacing={2} direction="row" >
            <Accordion style={{ width: "100%" }}>
              <AccordionSummary
                style={{
                  paddingLeft: "0px"
                }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography color="#3B6FCC">{msg}</Typography>
              </AccordionSummary>
              <AccordionDetails >
                <Typography >
                  {racSupplementArr}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </>

      // 食品添加物判定
      if (dataList[i].eu_product_code) {
        if (dataJudge(dataList[i].eu_exportability_code)) {
          icon = dataList[i].eu_exportability_code;
          supplement = dataList[i].eu_supplement;
          specialCond = dataList[i].eu_special_cond;
          url = dataList[i].eu_url;
          enableDate = dayjs(dataList[i].eu_enable_date).format("YYYY年MM月DD日");
        } else {
          icon = euNA.exportability_code;
          supplement = euNA.supplement;
          specialCond = euNA.special_cond;
          url = euNA.url;
          enableDate = dayjs(euNA.enable_date).format("YYYY年MM月DD日");
        }
        euSentence = {
          icon: icon,
          img: iconConversion(icon),
          supplement: supplement,
          special_cond: specialCond,
          url: url,
          enable_date: enableDate,
        }

        // 補足文言
        if (euSentence.supplement) {
          euSupplementArr.push(<div>{euSentence.supplement}</div>);
        }
        // 注釈
        if (euSentence.special_cond) {
          euSupplementArr.push(
            <div>
              <div style={{ wordBreak: "break-all" }}>
                {euUrlSplit(euSentence.special_cond, dataList[i].rac_product_code)}
              </div>
            </div>
          );
        }
        // URL
        if (euSentence.url) {
          euSupplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {/* <Link href={judgeSentence.url} target="_blank">{judgeSentence.url}</Link></div> */}
                {urlSplit(euSentence.url)}
              </div>
            </div>
          );
        }
      } else {
        euSentence = {
          icon: euNA.exportability_code,
          img: iconConversion(euNA.exportability_code),
          supplement: euNA.supplement,
          special_cond: euNA.special_cond,
          url: euNA.url,
          enable_date: dayjs(euNA.enable_date).format("YYYY年MM月DD日"),
        }

        // 補足文言
        if (euNA.supplement) {
          euSupplementArr.push(<div>{euNA.supplement}</div>);
        }
        // 注釈
        if (euNA.special_cond) {
          euSupplementArr.push(<div>{euNA.special_cond}</div>);
        }
        // URL
        if (euNA.url) {
          euSupplementArr.push(
            <div>
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {urlSplit(euNA.url)}
              </div>
            </div>
          );
        }
      }

      if (euSentence.icon == "?") {
        msg = "輸出できるかどうかの情報を把握していません。";
      } else if (euSentence.icon == "X") {
        msg = "輸出できません。";
      } else {
        msg = "輸出をするための条件があります。";
      }

      // 食品添加物検疫
      euRegulationData =
        <>
          <p style={{ textAlign: "right", fontSize: 15, marginBlockStart: 0, marginBlockEnd: 0 }}>有効日：{euSentence.enable_date}</p>
          <Stack spacing={2} direction="row" >
            <Accordion style={{ width: "100%" }}>
              <AccordionSummary
                style={{
                  paddingLeft: "0px"
                }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography color="#3B6FCC">{msg}</Typography>
              </AccordionSummary>
              <AccordionDetails >
                <Typography >
                  {euSupplementArr}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </>

      // 総合判定(植物or動物)
      if (priorityJudge(planSentence.icon, animalSentence.icon)) {
        compJudgeSentence = {
          icon: animalSentence.icon,
          supplement: animalSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: planSentence.icon,
          supplement: planSentence.supplement,
        }
      }
      // (漁獲証明書)
      if (priorityJudge(compJudgeSentence.icon, marineSentence.icon)) {
        compJudgeSentence = {
          icon: marineSentence.icon,
          supplement: marineSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (放射能)
      if (priorityJudge(compJudgeSentence.icon, radioSentence.icon)) {
        compJudgeSentence = {
          icon: radioSentence.icon,
          supplement: radioSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (残留農薬)
      if (priorityJudge(compJudgeSentence.icon, racSentence.icon)) {
        compJudgeSentence = {
          icon: racSentence.icon,
          supplement: racSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (食品添加物)
      if (priorityJudge(compJudgeSentence.icon, euSentence.icon)) {
        compJudgeSentence = {
          icon: euSentence.icon,
          supplement: euSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }

      //CSVデータ作成
      csvData.push(
        {
          product_name: productName,
          country_name: countryName,
          comp_icon: compJudgeSentence.icon,
          plan_icon: planSentence.icon,
          plan_remarks: csvSentence.plan_remarks,
          animal_icon: animalSentence.icon,
          animal_remarks:
            (
              animalSentence.enable_date
              + "\n" + animalSentence.supplement
              + "\n" + animalSentence.special_cond
              + "\n" + animalSentence.url
            ).replace(/\n{2,}/g, "\n"),
          marine_icon: marineSentence.icon,
          marine_remarks:
            (
              marineSentence.enable_date
              + "\n" + marineSentence.supplement
              + "\n" + marineSentence.special_cond
              + "\n" + marineSentence.url
            ).replace(/\n{2,}/g, "\n"),
          radio_icon: radioSentence.icon,
          radio_remarks: csvSentence.radio_remarks,
          rac_icon: racSentence.icon,
          rac_remarks:
            (
              racSentence.enable_date
              + "\n" + racSentence.supplement
              + "\n" + racSentence.special_cond
              + "\n" + racSentence.url
            ).replace(/\n{2,}/g, "\n"),
          eu_icon: euSentence.icon,
          eu_remarks:
            (
              euSentence.enable_date
              + "\n" + euSentence.supplement
              + "\n" + euSentence.special_cond
              + "\n" + euSentence.url
            ).replace(/\n{2,}/g, "\n"),
        }
      );

      // 総合判定をアイコンファイルと文言に変換
      let result = compIconConversion(compJudgeSentence.icon);

      // テーブル内の作成
      plantTableData.push(
        <>
          <td className="td2">植物検疫</td>
          <td className="td3">
            <img src={planSentence.img} />
          </td>
          <td className="td4">{planSentence.icon == "-" ? "" : planRegulationData}</td>
        </>
      );

      animalTableData.push(
        <>
          {/* <td className="td2">動物検疫及び<br />食品衛生</td> */}
          <td className="td2">動物衛生・食品衛生</td>
          <td className="td3">
            <img src={animalSentence.img} />
          </td>
          <td className="td4">{animalSentence.icon == "-" ? "" : animalRegulationData}</td>
        </>
      );

      
      marineTableData.push(
        <>
          <td className="td2">漁獲証明書</td>
          <td className="td3">
            <img src={marineSentence.img} />
          </td>
          <td className="td4">{marineSentence.icon == "-" ? "" : marineRegulationData}</td>
        </>
      );

      radioTableData.push(
        <>
          <td className="td2">放射性<br />物質</td>
          <td className="td3">
            <img src={radioSentence.img} />
          </td>
          <td className="td4">{radioSentence.icon == "-" ? "" : radioRegulationData}</td>
        </>
      );

      racTableData.push(
        <>
          <td className="td2">残留農薬</td>
          <td className="td3">
            <img src={racSentence.img} />
          </td>
          <td className="td4">{racSentence.icon == "-" ? "" : racRegulationData}</td>
        </>
      );

      euTableData.push(
        <>
          <td className="td2">食品添加物</td>
          <td className="td3">
            <img src={euSentence.img} />
          </td>
          <td className="td4">{euSentence.icon == "-" ? "" : euRegulationData}</td>
        </>
      );

      const rowSpan = 6;
      tableData.push(
        <>
          <tr>
            {/* <td rowSpan={rowSpan} className="td1" style={{ minWidth: "100px" }} >{productCode2}</td> */}
            <td rowSpan={rowSpan} className="td1">{countryName}</td>
            <td rowSpan={rowSpan} className="td2"
              style={{ textAlign: "center", border: "3px solid #1B335E" }}>
              {result}
            </td>
            {plantTableData}
          </tr>
          <tr>
            {animalTableData}
          </tr>
          <tr>
            {marineTableData}
          </tr>
          <tr>
            {radioTableData}
          </tr>
          <tr>
            {racTableData}
          </tr>
          <tr>
            {euTableData}
          </tr>
        </>
      );
    }
    console.log(csvData)
    setCsvData(csvData);
    return tableData;
  }

  function setNAPacking(planNA) {
    let exportability = [];
    let packing = [];

    exportability.push(
      <tbody>
        <tr>
          <td className="min-td" style={{ textAlign: "center" }}>
            {planNA.packing}
          </td>
          <td className="min-td" style={{ textAlign: "center" }}>
            <img src={iconConversion(planNA.exportability_code)} />
          </td>
          <td className="min-td2" style={{ textAlign: "left" }}>
            <Stack spacing={0}>
              {/* 補足文言 */}
              <div>{planNA.supplement}</div>
              {/* 注釈 */}
              <div>{planNA.special_cond}</div>
              {/* URL */}
              <div>参考URL</div>
              <div style={{ wordBreak: "break-all" }}>
                {urlSplit(planNA.url)}
              </div>
            </Stack>
          </td>
        </tr>
      </tbody>
    );

    packing.push(
      <>
        <p>輸送方法によって判定が違いますのでご注意ください。</p>
        <div className="d002_item">
          <table bordercolor="darkgray" style={{ minWidth: "100%", fontSize: "14px" }}>
            <thead className="thead2">
              <tr>
                <th>輸送方法</th>
                <th>輸出可否判定</th>
                <th>備考</th>
              </tr>
            </thead>
            {exportability}
          </table>
        </div>
      </>
    );

    return packing;
  }

  // 放射能データ
  async function getRadioData(country_code, product_code) {
    let radioDataList = [];
    body = { authKey: API.API_KEY };
    body.countryCode = country_code;
    body.productCode = product_code;
    let res = await axios.post("/m_radio_active_product/select/radio", body);
    radioDataList = res.data.dataList;
    return radioDataList;
  }

  // 結果画面
  function backClick() {
    return navigate("/D002SearchResult", { state: { dataList: dataList, productName: productName } });
  }

  // 残留農薬チェック画面
  async function racClick(country_code, product_code) {
    try {
      let productName = "";
      let countryName = "";

      body = { authKey: API.API_KEY };
      body.countryCode = country_code;
      body.productCode = product_code;
      let res = [];
      // 残留農薬用　品目名取得
      res = await axios.post("/m_synonym_product/select/product", body);
      const synProDataList = res.data.dataList;

      let productList = [];
      for (let i in synProDataList) {
        productList.push(synProDataList[i].product_name);
      }
      if (productList) {
        body.productList = productList;
        res = await axios.post("/m_rac_product/select", body);
        if (res.data.dataList.length > 0) {
          productName = res.data.dataList[0].product_name;
        }
      }

      // 残留農薬用　国名取得
      if (country_code) {
        res = await axios.post("/m_synonym_country/select", body);
        const synCouDataList = res.data.dataList;

        let countryList = [];
        for (let i in synCouDataList) {
          countryList.push(synCouDataList[i].country_name);
        }
        if (countryList) {
          body.countryList = countryList;
          res = await axios.post("/m_rac_export_country/select", body);
          if (res.data.dataList.length > 0) {
            countryName = res.data.dataList[0].country_name;
          }
        }
      }

      let eachData = { product_name: productName, country_name: countryName };
      return navigate("/D0121RacTop", { state: { eachData: eachData } });
    } catch (err) {
      console.log(err)
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // EU食品添加物チェック画面改行用
  function euUrlSplit(specialCond, productCode) {
    if (!specialCond) {
      return;
    }

    let urlList = specialCond.split(/\r\n|\n/);
    let urlArr = [];
    for (const [i, url] of urlList.entries()) {
      urlArr.push(
        <>
          <div>{euSplit(url, productCode)}</div>
        </>
      );
    }
    return urlArr;
  }

    // EU食品添加物チェック画面用クリック変換
    function euSplit(specialCond, productCode) {
      const specialCondStr = "EU食品添加物チェック";
      let specialCondList = specialCond.split(/(EU食品添加物チェック)/);
      let specialCondArr = [];
      for (const [i, specialCond] of specialCondList.entries()) {
        if (specialCond.startsWith(specialCondStr)) {
          specialCondArr.push(
            <>
              <Link onClick={() => euClick(productCode)} style={{ cursor: "pointer" }}>EU食品添加物チェック</Link>
            </>
          );
        } else {
          specialCondArr.push(
            specialCond
          );
        }
      }
      return specialCondArr;
    }

  // EU食品添加物チェック画面
  function euClick(productName) {
    return navigate("/D0131FoodAdditive", { state: { product_name: productName } });
  }

  /**
   * テキスト内に複数のURLが含まれていたときに改行文字で分割する
   * 先頭文字が「http」始まりをリンクに変換する
   * @param {*} urlColumn URL文字
   * @returns 説明＋URL
   */
  function urlSplit(urlColumn) {
    if (!urlColumn) {
      return;
    }
    let urlList = urlColumn.split(/\r\n|\n/);
    let urlArr = [];
    for (const [i, url] of urlList.entries()) {
      if (url.startsWith("http")) {
        urlArr.push(
          <>
            <Link href={url} target="_blank">{url}</Link>
            <br />
          </>
        );
      } else {
        urlArr.push(
          <div>{url}</div>
        );
      }
    }
    return urlArr;
  }

  return (
    <>
      <MenuMenu sel={1} />
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                {/* Loading */}
                <Backdrop open={isLoading}
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                  <CircularProgress />
                </Backdrop>
                <Stack spacing={2}>
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    {/* <Link underline="hover" key="2" color="inherit" href="" onClick={backClick}>
                      規制情報詳細
                    </Link>, */}
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      規制情報詳細
                    </Typography>
                  </Breadcrumbs>
                  <h1>規制情報詳細</h1>
                  {/* <p>このサイトでの判定は、「植物検疫」、「動物検疫及び食品衛生」、「放射性物質」、「残留農薬」、「食品添加物」の5つの規制を基に判定結果を出しています。各条件の詳細は「さらに詳細を見る」ボタンをクリックするとご覧いただけます。</p> */}
                  <p>本サイトは、「植物検疫」、「動物衛生・食品衛生」、「漁獲証明書」、「放射性物質」の４つの要件・規制を基に簡易判定結果を出しています。<br />
                    各要件・規制に関する情報は、二国間での合意内容や各国・地域の当局情報に基づいて作成しておりますが、調査時点の内容であり、その後変更されていることがあります。<br />
                    また、表示規制やハラールなど、本サイトで取り上げていない措置についても対応する必要がありますので、実際に輸出するに当たっては、輸出先国の関係法規を確認してください。</p>
                  <div style={{ textAlign: "right" }}>
                    <CSVLink style={{ color: "white", textDecoration: "none" }}
                      filename={"簡易輸出判定.csv"} headers={csvHeader} data={csvData}>
                      <Button
                        style={{
                          width: "200px"
                        }}
                        class="buttonDefault"
                        sx={{ backgroundColor: "#22335C" }}
                      >CSVダウンロード
                      </Button>
                    </CSVLink>
                  </div>
                  <div className="center">
                    {judge}
                  </div>

                  <div style={{
                    display: "flex"
                    , justifyContent: "center"
                    , position: "relative"
                    , flexWrap: "wrap"
                    , marginTop: "40px"
                    , marginBottom: "40px"
                  }}>
                    <input type="button" style={{ width: "150px", color: "#1B335E", margin: "0 10px" }} value="戻る" class="buttonDefault graylBtn" onClick={backClick} />
                  </div>

                  {/* <div style={{ textAlign: "center" }}>
                    <Button className="search_button"
                      style={{ borderRadius: "28px" }}
                      onClick={backClick}>
                      戻る
                    </Button>
                  </div> */}
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default D003SearchDetail;